import React, { createContext, useEffect, useState } from 'react';
import { createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, updateProfile } from "firebase/auth";
import app from '../firebase/Firebase.config';

export const AuthContext = createContext()
const auth = getAuth(app)

const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(null)
    const [loading,setLoading]=useState(true)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, CurrentUser => {
            setUser(CurrentUser)
            setLoading(false);
        })
        return () => unsubscribe()
    }, [])


    const createUser = (email, password) => {
        setLoading(true);
        return createUserWithEmailAndPassword(auth, email, password)
    }

    const loginUser = (email, password) => {
        setLoading(true)
        return signInWithEmailAndPassword(auth, email, password)
    }

    const updateUser = (userInfo) => {
        return updateProfile(auth.currentUser, userInfo)
    }

    const userlogOut = () => {
        setLoading(true)
        return signOut(auth)
    }


    const AuthInfo = {
        createUser,
        loginUser,
        user,
        loading,
        updateUser,
        userlogOut
    }

    return (

        <AuthContext.Provider
            value={AuthInfo}
        >
            {children}

        </AuthContext.Provider>
    );
};

export default AuthProvider;